import {Injectable} from '@angular/core';
import {AuthService} from "./auth.service";
import {HttpClient} from "@angular/common/http";
import {getStorage, ref as storageRef, uploadBytes, deleteObject, getDownloadURL} from "@angular/fire/storage";

@Injectable({
  providedIn: 'root'
})
export class FontService {

    public waitingForImage = false;

    storage;
    storageRef;

    constructor(private authService: AuthService,
                private http: HttpClient) {
        this.storage = getStorage();
        this.storageRef = storageRef(this.storage, 'product-images/null');
    }

    async uploadBodyFont(font: File, uid: string) {
        this.storageRef = storageRef(this.storage, 'fonts/' + uid);
        return uploadBytes(this.storageRef, font).then((snapshot) => {
            return uid;
        });
    }

    async uploadHeadlineFont(font: File, uid: string) {
        this.storageRef = storageRef(this.storage, 'fonts/headlines/' + uid);
        return uploadBytes(this.storageRef, font).then((snapshot) => {
            return uid;
        });
    }

    async getBodyFont(uid: string) {
        try {
            return await getDownloadURL(storageRef(this.storage, 'fonts/' + uid));
        } catch (e) {
            return "";
        }
    }

    async getHeadlineFont(uid: string) {
        try {
            return await getDownloadURL(storageRef(this.storage, 'fonts/headlines/' + uid));
        } catch (e) {
            return "";
        }
    }

    async removeBodyFont(uid: string) {
        return deleteObject(storageRef(this.storage, 'fonts/' + uid)).then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }

    async removeHeadlineFont(uid: string) {
        return deleteObject(storageRef(this.storage, 'fonts/headlines/' + uid)).then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }

}
